import { unescape } from 'lodash-es';
import DOMPurify from 'isomorphic-dompurify';
const plugin = (_, inject) => {
    inject('dompurify', (html) => unescape(DOMPurify.sanitize(html)));
};
export default plugin;
